export default {
  NEW_ERROR_EVENT: "[messages] New Error Event",
  NEW_MESSAGE_EVENT: "[messages] New Message Event",
  NEW_SUCCESS_EVENT: "[messages] New Success Event",
  CLEAR_LATEST_MESSAGE: "[messages] Clear Latest Message",
  SET_FORM_ERRORS: "[messages] SET Form Errors",
  GET_FORM_ERRORS: "[messages] GET Form Errors",
  // INSERTION_PT (for script, do not remove)
};
